$(document).ready(function() {
  let reviewElementsArray = []; // Global array to store valid 5-star reviews
  let currentPage = 1; // Start with the first page
  const maxReviews = 50; // We need at least 50 reviews
  const paginationSelector = '.yotpo-reviews-pagination-item.yotpo-pagination-number'; // Pagination selector for desktop
  let isLoadingReviews = false; // Flag to prevent multiple clicks or infinite loops
  let slickInitialized = false; // Flag to track slick initialization
  let lastProcessedIndex = 0; // Index to track where we left off with reviews (only used for "Load more")
  let globalReviewIndex = 0; // Unique index across pagination and "Load more"

  // Function to simulate a native DOM click event
  function simulateClick(element) {
    const event = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    element.dispatchEvent(event);
  }

  // Function to check if an element has overflow
  function isOverflowing(element) {
    return element.scrollHeight > element.clientHeight;
  }

  // Function to run the overflow check after slides are generated
  function checkOverflowAndUpdateVisibility() {
    $('.mediablock__review-description').each(function() {
      var $description = $(this);
      var $panel = $description.closest('.mediablock__review').find('.mediablock__review-panel');
      
      // Check if the review description is overflowing
      if (isOverflowing(this)) {
        // Remove visibility:hidden from the review panel
        $description.parent().parent().parent().find('.mediablock__review-panel').removeAttr('style');
      }
    });
  }

  // Function to create review slide and its corresponding modal
  function createReviewSlideAndModal(reviewerName, reviewTitle, reviewDate, reviewContent, index) {
    reviewerName = reviewerName.replace('...', '');

    // Generate the slide with broadcast linking to modal
    const slide = `
      <div class="relative">
        <div class="mediablock__review">
          <div class="mediablock__review-content">
            <div class="mediablock__review-stars flex">
              <img width="90" height="auto" src="//buffy.co/cdn/shop/files/full-stars_1024x1024.png?v=1678198959" alt="Star to signify a review.">
            </div>
            <p class="no-margin mediablock__review-name">${reviewerName}</p>
            <p class="no-margin mediablock__review-date">${reviewDate}</p>
            <h2 class="no-margin mediablock__review-headline">${reviewTitle}</h2>
            <p class="no-margin p mediablock__review-description">${reviewContent}</p>
          </div>
        </div>
        <div class="mediablock__review-panel" style="visibility: hidden;">
          <hh-broadcast on="click" event="modal" aria-haspopup="dialog" data="{&quot;id&quot;: &quot;review-${index}&quot;}">
            <div class="mediablock__review-more" aria-hidden="true" role="button">
              <span>Read more<aside class="button-aside" role="none"></aside></span>
            </div>
          </hh-broadcast>
        </div>
      </div>
    `;

    // Generate the corresponding modal
    const modal = `
      <hh-modal class="review-modal" id="review-${index}" data-type="modal" open="false">
        <div class="mediablock__review-content">
          <div class="mediablock__reivew-stars flex">
            <div class="flex">
              <img src="//cdn.shopify.com/s/files/1/2462/9621/files/Star_transp.png?v=1614314402" alt="Star to signify a review.">
            </div>
            <div class="flex">
              <img src="//cdn.shopify.com/s/files/1/2462/9621/files/Star_transp.png?v=1614314402" alt="Star to signify a review.">
            </div>
            <div class="flex">
              <img src="//cdn.shopify.com/s/files/1/2462/9621/files/Star_transp.png?v=1614314402" alt="Star to signify a review.">
            </div>
            <div class="flex">
              <img src="//cdn.shopify.com/s/files/1/2462/9621/files/Star_transp.png?v=1614314402" alt="Star to signify a review.">
            </div>
            <div class="flex">
              <img src="//cdn.shopify.com/s/files/1/2462/9621/files/Star_transp.png?v=1614314402" alt="Star to signify a review.">
            </div>
          </div>
          <p class="no-margin mediablock__review-name">${reviewerName}</p>
          <p class="no-margin mediablock__review-date">${reviewDate}</p>
          <h2 class="no-margin mediablock__review-headline">${reviewTitle}</h2>
          <p class="no-margin p mediablock__review-description">${reviewContent}</p>
        </div>
      </hh-modal>
    `;

    return { slide, modal };
  }

  // Function to initialize the slick carousel only once, after the first page is processed
  function initializeSlick() {
    if (!slickInitialized && $('.zjs-carousel-slick').length > 0) { 
      $('.zjs-carousel-slick').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
      slickInitialized = true;
   //   console.log('Slick initialized with first set of reviews.');
    }
  }

  // Function to add all slides and modals
  function addSlidesAndModals(reviewsArray) {
    if (!slickInitialized) {
      console.warn('Slick carousel is not initialized yet. Initializing now...');
      initializeSlick(); // Ensure initialization
    }

    let slidesHtml = '';
    let modalsHtml = '';
    reviewsArray.forEach(function(review) {
      globalReviewIndex++; // Ensure unique global index for every review
      const { slide, modal } = createReviewSlideAndModal(
        review.reviewerName,
        review.reviewTitle,
        review.reviewDate,
        review.reviewContent,
        globalReviewIndex // Use global unique index
      );
      slidesHtml += slide;
      modalsHtml += modal;
    });

    // Add the slides and modals
    if (slickInitialized) {
      $('.review-carousel-holder-relative.zjs-carousel-slick').slick('slickAdd', slidesHtml);
      $('hh-review-carousel').append(modalsHtml);

      // After slides have been added, check for overflowing descriptions and update visibility
      setTimeout(checkOverflowAndUpdateVisibility, 500); // Delay to ensure DOM rendering is complete
    }
  }

  // Function to add a batch of reviews to the results array
  function addBatchReviewsToResults(reviewsArray) {
    reviewsArray.forEach(({ reviewerName, reviewTitle, reviewDate, reviewContent }) => {
      reviewElementsArray.push({
        reviewerName,
        reviewTitle,
        reviewDate,
        reviewContent,
      });
    });

    addSlidesAndModals(reviewsArray); // Add the current batch of reviews to slick

    if (reviewElementsArray.length >= maxReviews) {
    //  console.log('Collected 50 reviews. Stopping further review collection.');
      return;
    }

    isLoadingReviews = false; // Allow further pagination or load more
  }

  // Function to process reviews on the current page (for "Load more" we use index tracking, but for pagination we don't)
  function processReviewsOnPage(isPagination = false) {
    if (reviewElementsArray.length >= maxReviews) {
   //   console.log('Collected 50 reviews. Stopping further review collection.');
      return; // Stop further processing once 50 reviews have been collected
    }

    let reviewsToAdd = [];

    $('.yotpo-review').each(function(i, el) {
      // For pagination, we ignore index, for "Load more," we use index tracking
      if (!isPagination && i < lastProcessedIndex) {
        return; // Skip already processed reviews (only for "Load more")
      }

      if (reviewElementsArray.length >= maxReviews) {
        return; // Exit if we already have 50 reviews
      }

      const ratingText = $(el).find('.sr-only').text();
      if (ratingText.includes('5 star rating')) {
        const reviewerName = $(el).find('.yotpo-reviewer-name').text().trim();
        const reviewTitle = $(el).find('.yotpo-review-title').text().trim();
        const reviewDate = $(el).find('.yotpo-review-date .yotpo-date-format').text().trim();
        let reviewContent = $(el).find('.yotpo-read-more-text').text().trim();

        const readMoreLink = $(el).find('.yotpo-read-more');
        if (readMoreLink.length > 0) {
          readMoreLink[0].click();
          setTimeout(() => {
            reviewContent = $(el).find('.yotpo-read-more-text').text().trim();
            reviewsToAdd.push({
              reviewerName,
              reviewTitle,
              reviewDate,
              reviewContent,
            });
          }, 250); 
        } else {
          reviewsToAdd.push({
            reviewerName,
            reviewTitle,
            reviewDate,
            reviewContent,
          });
        }
      }
    });

    if (!isPagination) {
      lastProcessedIndex = $('.yotpo-review').length; // Update the last processed index for "Load more"
    }

    setTimeout(() => {
      addBatchReviewsToResults(reviewsToAdd);
    }, 300); // Add reviews after slight delay
  }

  // Function to handle mobile "Load more reviews" button or desktop pagination
  function handlePaginationOrLoadMore() {
    if (reviewElementsArray.length >= maxReviews) {
   //   console.log('Collected 50 reviews. No further pages will be processed.');
      return; // Stop further pagination or load more when 50 reviews are collected
    }

    if (isLoadingReviews) {
      return; // Prevent multiple loading attempts
    }
    isLoadingReviews = true;

    const loadMoreButton = document.querySelector('.yotpo-reviews-pagination-item[aria-label="Load more reviews"]');
    const nextPageLink = $(`${paginationSelector}[aria-label="Goto Page ${currentPage + 1}"]`);

    if (loadMoreButton && reviewElementsArray.length < maxReviews) {
    //  console.log('Simulating click on "Load more reviews" button');
      simulateClick(loadMoreButton);
      setTimeout(function() {
        processReviewsOnPage(false); // Process reviews on the new page (use index tracking for "Load more")
        handlePaginationOrLoadMore(); // Recursively handle the load more button
      }, 1000);
    } else if (nextPageLink.length > 0 && reviewElementsArray.length < maxReviews) {
      // Desktop: Handle pagination
      currentPage++;
      simulateClick(nextPageLink[0]); // Simulate clicking the pagination link
      setTimeout(function() {
        processReviewsOnPage(true); // Process reviews on the new page (ignore index for pagination)
        handlePaginationOrLoadMore(); // Recursively go to the next page
      }, 1500); // Slightly longer timeout to allow new content to load
    } else {
   //   console.log('No more reviews to load.');
      isLoadingReviews = false; // Stop loading
    }
  }

  // Start processing based on whether it's mobile or desktop
  function startReviewCollection() {
    processReviewsOnPage(false); // Process the first set of reviews
    handlePaginationOrLoadMore(); // Handle pagination or load more logic
  }

  // Function that will be called once the element is found
  function executeWhenFound() {
    var reviewText = parseInt($('.js-product-panel').find('.yotpo-sr-bottom-line-text.yotpo-sr-bottom-line-text--right-panel').text().trim().replace(' Reviews',''));
  //  console.log('my split up reviews are ' + reviewText);
    reviewText = reviewText.toLocaleString();
    reviewText = reviewText + ' Reviews';
    var path = window.location.pathname;

    // Handling custom review counts for specific paths
    if (path === '/products/supima-cotton-duvet-cover') {
      reviewText = '18,565 Reviews';
    } else if (path === '/products/supima-cotton-sheet-set') {
      reviewText = '14,451 Reviews';
    } else if (path === '/products/belgian-linen-sheet-set') {
      reviewText = '7,894 Reviews';
    } else if (path === '/products/belgian-linen-duvet-cover') {
      reviewText = '10,182 Reviews';
    }

    $('.review-number-yotpo').text(reviewText);

    var overall_score = $('.js-product-panel').find('.sr-only').text().trim();
    overall_score = overall_score.replace(' out of 5 star rating', '');
    if (overall_score != '') {
      var starHtml = '<a class="stars__header" href="#reviewAnchor" title="Reviews ' + overall_score + '" aria-label="Reviews (' + overall_score + ')"><h3 class="stars__title p font-body-bold no-margin">Reviews (' + overall_score + ')</h3><div class="stars-image-wrapper"><img src="https://cdn.shopify.com/s/files/1/2462/9621/files/full-stars_1024x1024-4.5.png?v=1728656436" alt="Review stars." width="300" height="49"></div></a>';
      $('.stars').append(starHtml);
      $('.stars').show();
      $('#reviewAnchor').css('display', 'grid');
      $('.yotpo-overall-score').text(overall_score);

      if ($('.yotpo-reviews-list').find('.yotpo-review-content').length > 0) {
        // Start the process by processing the first page
        processReviewsOnPage(false);
        handlePaginationOrLoadMore();  // Check if it's mobile or desktop and handle pagination/load more
      } else {
        $('.stars').hide();
        $('#reviewAnchor').hide();
      }
    }

    // Call the review collection function to start processing
    startReviewCollection();  
  }
  // if review manual carousel doesnt exist, we just run the normal play with Yotpo
  if ($('.review__carousel.manual').length === 0) {
   // console.log('i dont think manual exists');
      // Setting up the interval to check for the element
  let checkExist = setInterval(function() {
    if ($('div[data-yotpo-instance-id="633603"]').attr('data-yotpo-element-loaded') === 'true') {
      if ($('.yotpo-reviews-list').find('.yotpo-review-content').length > 0 && $('.js-product-panel').find('.yotpo-sr-bottom-line-text.yotpo-sr-bottom-line-text--right-panel').length > 0) {
   //     console.log('New review app is loaded');
        clearInterval(checkExist);  // Stop the interval
        executeWhenFound();  // Call the desired function
      }
    } else {
   //   console.log('I keep looking for this element');
    }
  }, 250);
}
else {
 //     console.log('trying to run manual part');
  // review manual exists, we need to show the review Anchor and slick the current slides
  initializeSlick();
  $('#reviewAnchor').css('display','grid');
  $('.zjs-carousel-slick.relative').show();
  var interval = setInterval(function() {
    // Check if the element exists and has an opacity of 1
    var opacity = $('.custom-star-bundle').css('opacity');
//    console.log('my opacity is ' + opacity);
    if (opacity == '1') {
        // Run your logic here
        var reviewText = $('.js-product-panel').find('.yotpo-sr-bottom-line-text.yotpo-sr-bottom-line-text--right-panel').eq(0).text().trim();
        $('.review-number-yotpo').text(reviewText);
        var overall_score = $('.js-product-panel').find('.sr-only').eq(0).text().trim();
        overall_score = overall_score.replace(' out of 5 star rating', '');
     //   console.log('my overall score is ' + overall_score);
        if (overall_score != '') {
          var starHtml = '<a class="stars__header" href="#reviewAnchor" title="Reviews ' + overall_score + '" aria-label="Reviews (' + overall_score + ')"><h3 class="stars__title p font-body-bold no-margin">Reviews (' + overall_score + ')</h3><div class="stars-image-wrapper"><img src="https://cdn.shopify.com/s/files/1/2462/9621/files/BuffyStarsNewV2.png?v=1744152324" alt="Review stars." width="300" height="49"></div></a>';
          $('.stars').append(starHtml);
          $('.stars').show();
          $('.yotpo-overall-score').text(overall_score);
        }
        checkOverflowAndUpdateVisibility();
        // Clear the interval to stop the check
        clearInterval(interval);
    }
    else {
    //  console.log('keep checking');
    }
}, 500); // The interval checks every 100 milliseconds (you can adjust this timing if needed)

    }
});
